import { useEffect, useState } from 'react';
import { getSignedProfileUrl } from './supabaseClient';

const DEFAULT_PROFILE = '/images/Profile.png';

// Resolves a stored profile_url (legacy public URL or storage path) to a
// short-lived signed URL before rendering, since the id-profile bucket is
// private and the raw path/URL isn't directly viewable.
export default function SignedProfileImage({ profileUrl, alt = 'Profile', ...imgProps }) {
    const [src, setSrc] = useState(DEFAULT_PROFILE);

    useEffect(() => {
        let cancelled = false;

        if (!profileUrl) {
            setSrc(DEFAULT_PROFILE);
            return;
        }

        getSignedProfileUrl(profileUrl).then((signedUrl) => {
            if (!cancelled) setSrc(signedUrl || DEFAULT_PROFILE);
        });

        return () => {
            cancelled = true;
        };
    }, [profileUrl]);

    return <img src={src} alt={alt} {...imgProps} />;
}
